import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '@/store/index'

// 根据查询条件查询重要视频
export function getImportantVideo(params) {
  const url = IhLogUrl + '/mediasTag/page/important/video'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('焦点关注', '查询重要视频', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.list.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.lowMediaUrl) {
            item.lowMediaUrl = item.lowMediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.preMediaUrl) {
            item.preMediaUrl = item.preMediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.groupVideoList) {
            item.groupVideoList.forEach(i => {
              if (i.mediaUrl) {
                i.mediaUrl = i.mediaUrl.replace(replaceFrom, replaceTo)
              }
              if (item.preMediaUrl) {
                i.preMediaUrl = i.preMediaUrl.replace(replaceFrom, replaceTo)
              }
            })
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

// 根据查询条件查询重要图片
export function getImportantPhoto(params) {
  const url = IhLogUrl + '/logs/page/photo'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('焦点关注', '查询重要图片', res)
    }
    return Promise.resolve(res.data)
  })
}

// 保存视频或图片备注
export function saveFileDesc(data) {
  const url = IhLogUrl + '/medias/describe'
  return axios({
    method: 'put',
    url: url,
    data,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('焦点关注', '编辑视频/图片备注', res)
    }
    return Promise.resolve(res.data)
  })
}

// 保存视频或图片备注
export function saveGpsDesc(data) {
  const url = IhLogUrl + '/gps/describe'
  return axios({
    method: 'put',
    url: url,
    data,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('焦点关注', '编辑轨迹备注', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 标记、取消标记重要轨迹
 */
export function cancleGpsFlag(params) {
  const url = IhLogUrl + '/gps/mark/important'

  return axios({
    method: 'get',
    url: url,
    params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('焦点关注', '取消重要轨迹标记', res)
    }
    return Promise.resolve(res.data)
  })
}
